const scalar = (value) => Array.isArray(value) ? value[0] : value;

const studentId = (student) => String(scalar(student?.AlunoID) ?? scalar(student?.id) ?? '');
const studentName = (student) => String(scalar(student?.Nome) ?? scalar(student?.name) ?? 'Aluno sem nome');

export const buildEventClassroomReport = (students = [], enrollments = [], classroomId, participation = []) => {
  const targetClassroomId = String(classroomId ?? '');
  const classroomEnrollments = enrollments.filter((item) => String(item.classroomExternalIdSnapshot) === targetClassroomId);
  const enrollmentByStudent = new Map(classroomEnrollments.map((item) => [String(item.studentExternalIdSnapshot), item]));

  const responses = new Map(participation.map(item => [String(item.studentExternalId), item.response]));
  const rows = students.map((student) => {
    const id = studentId(student);
    const enrollment = enrollmentByStudent.get(id) || null;
    const payment = enrollment?.payments?.[0] || null;
    const participationResponseRequired = !enrollment || ['PAYMENT_PENDING', 'PARTIALLY_PAID'].includes(enrollment.status);
    return {
      studentId: id,
      studentName: studentName(student),
      callNumber: scalar(student?.NumeroChamada) ?? null,
      enrollment,
      payment,
      confirmed: enrollment?.status === 'CONFIRMED',
      response: responses.get(id) || 'WAITING',
      participationResponseRequired,
    };
  }).sort((a, b) => {
    const callA = Number(a.callNumber);
    const callB = Number(b.callNumber);
    if (Number.isFinite(callA) && Number.isFinite(callB) && callA !== callB) return callA - callB;
    return a.studentName.localeCompare(b.studentName, 'pt-BR');
  });

  const paid = rows.filter((row) => row.confirmed).length;
  const pending = rows.filter((row) => ['PAYMENT_PENDING', 'PARTIALLY_PAID'].includes(row.enrollment?.status)).length;
  const notEnrolled = rows.filter((row) => !row.enrollment).length;
  return {
    rows,
    total: rows.length,
    paid,
    pending,
    notEnrolled,
    declined: rows.filter(row => row.response === 'DECLINED').length,
    participationConfirmed: rows.filter(row => row.response === 'CONFIRMED').length,
    missingConfirmation: rows.filter(row => row.response === 'WAITING' && row.participationResponseRequired).length,
  };
};
